// Dev-only configuration for hidden tools
// Access code is sourced from env at build time to avoid committing secrets

export const devConfig = {
  TEST_ACCOUNTS_ACCESS_CODE: process.env.REACT_APP_TEST_ACCOUNTS_ACCESS_CODE
};

export default devConfig;
